import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M100 31.5131C100 52.1236 83.8642 68.0691 59.4401 92.2027L52.7093 98.8834C51.9606 99.6296 50.9791 100 50 100C49.0259 100 48.0494 99.6296 47.3007 98.8934L40.6075 92.3028C16.0757 68.004 0 52.081 0 31.5131C0 13.8423 12.8405 0.000183105 29.2318 0.000183105C36.8239 0.000183105 44.3184 3.16524 50 8.63149C55.6791 3.16524 63.1761 0.000183105 70.7682 0.000183105C87.1594 0.000183105 100 13.8423 100 31.5131Z'

const IconHeartFilled: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} />
)

export default IconHeartFilled
